import { List } from 'immutable'
import moment from 'moment'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Table from '../common/table'

export default function ContentList(props) {
  let { content, t, oldMaterial, routePrefix } = props

  let columns = [
    {
      key: 'id',
      label: t('content.tableName'),
      render(item) {
        return <Link to={`${routePrefix}/content/${item.get('id')}`}>{item.get('label')}</Link>
      },
    },
    {
      key: 'material_count',
      label: t('content.tableMaterials'),
      width: 140,
      align: 'center',
      render: item => item.get('materials', List()).size,
    },
    {
      key: 'delivered_at',
      label: t('content.tableDeliveredAt'),
      width: 200,
      align: 'center',
      render(item) {
        return moment(item.get('delivered_at')).format('L')
      },
    },
  ]

  return (
    <Fragment>
      <div className="page-view">
        <Table rows={content} columns={columns} id="id" />
      </div>
      {oldMaterial ? (
        <div className="old-material">
          <div className="old-material-title">{t('content.oldMaterialInfo')}</div>
          <div className="old-material-link">
            <a href={oldMaterial} target="_BLANK">
              {t('content.oldMaterialLink')}
              <i className="fa fa-external-link-square-alt" />
            </a>
          </div>
        </div>
      ) : null}
    </Fragment>
  )
}
